import { render, staticRenderFns } from "./LogisticDispatch.vue?vue&type=template&id=6d59775a&"
import script from "./LogisticDispatch.vue?vue&type=script&lang=js&"
export * from "./LogisticDispatch.vue?vue&type=script&lang=js&"
import style0 from "./LogisticDispatch.vue?vue&type=style&index=0&lang=css&"
import style1 from "./LogisticDispatch.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports